import { createFileRoute } from '@tanstack/react-router';

import { TransactionDetailPage } from '@/features/transactions/public';

const TransactionDetailsRoute = () => {
  const { id } = Route.useParams();
  return <TransactionDetailPage id={id} />;
};

export const Route = createFileRoute('/transactions/$id')({
  component: TransactionDetailsRoute,
});
